import { DemoRadioGroupExamples } from "./DemoRadioGroupExamples";
import { LiveExampleComponents } from "../LiveExampleComponents";

export class DemoRadioButtonGroupExamples extends DemoRadioGroupExamples {
    protected override registerExamples() {
        super.registerExamples();
        this.registerPropertyExamples("buttonFillColor", {
            examples: [
                { value: "primary", description: "A radio button using the default color ('primary')."},
                { value: "success", description: "A radio button using the 'success' color."}
            ],
            onCreate: (exampleComponents: LiveExampleComponents) => this.selectFirstOption(exampleComponents)
        });
        this.registerPropertyExamples("buttonSize", {
            examples: [
                { value: 14, description: "A radio button that's half the size of the default"},
                { value: 56, description: "A radio button that's twice the size of the default"}
            ],
            onCreate: (exampleComponents: LiveExampleComponents) => this.selectFirstOption(exampleComponents)
        });
    }
}
